<template>
    <b-form @submit.prevent="onSubmit">
      <!-- Name -->
      <b-form-group :label="$t('Name')" label-for="name">
        <b-form-input id="name" v-model="planData.name"
            autofocus :state="errors && ('name' in errors) ? false : null"
            trim autocomplete="off" placeholder=""
        />
        <b-form-invalid-feedback v-if="errors && ('name' in errors)"
                                 :state="errors && ('name' in errors) ? false : null">
          {{ $t(errors.name[0])  }}
        </b-form-invalid-feedback>
      </b-form-group>


      <!-- device -->
      <b-form-group :label="$t('Device')" label-for="device" :state="null">
        <v-select v-model="planData.device_id"
                  label="name" :reduce="val => val.device_id"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="devicesOptions" :clearable="true" input-id="device"
        />

        <b-form-invalid-feedback v-if="errors && ('device_id' in errors)"
                                 :state="errors && ('device_id' in errors) ? false : null">
          {{ $t(errors.device_id[0])  }}
        </b-form-invalid-feedback>
      </b-form-group>


      <!-- Camp -->
      <b-form-group :label="$t('Camp')" label-for="camp" :state="null">
        <v-select v-model="planData.camp_id" label="name"
            :reduce="val => val.geofence_id" :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="campsOption" :clearable="false" input-id="camp"
        />
        <b-form-invalid-feedback v-if="errors && ('camp_id' in errors)"
                                 :state="errors && ('camp_id' in errors) ? false : null">
          {{ $t(errors.camp_id[0])  }}
        </b-form-invalid-feedback>
      </b-form-group>


      <b-row>

        <b-col cols="6">
          <!-- leave camp time -->
          <b-form-group :label="$t('Leave Camp Time')" label-for="leave-camp" :state="null">
            <flat-pickr v-model="planData.camp_leave"
                        class="form-control" :class="{ 'is-invalid' : errors && ('camp_leave' in errors) }"
                        :config="flatPickerConfig"
                        placeholder="HH:MM:SS"
            />
            <b-form-invalid-feedback v-if="errors && ('camp_leave' in errors)"
                                     :state="errors && ('camp_leave' in errors) ? false : null">
              {{ $t(errors.camp_leave[0]) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="6">
          <!-- back camp time -->
          <b-form-group :label="$t('Back Camp Time')" label-for="back-camp" :state="null">
            <flat-pickr v-model="planData.camp_back" :state="null" class="form-control"
                        :class="{ 'is-invalid' : errors && ('camp_back' in errors) }"
                        :config="flatPickerConfig" placeholder="HH:MM:SS"
            />
            <b-form-invalid-feedback v-if="errors && ('camp_back' in errors)"
                                     :state="errors && ('camp_back' in errors) ? false : null">
              {{ $t(errors.camp_back[0]) }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <label>{{ $t('service areas')}}</label>
          <area-form-repeater :items.sync="areasItems" :options="areasOption">
            <template v-slot:error>
              <b-form-invalid-feedback v-if="errors && ('areas' in errors)"
                                       :state="errors && ('areas' in errors) ? false : null">
                {{ $t(errors.areas[0]) }}
              </b-form-invalid-feedback>
            </template>
          </area-form-repeater>
        </b-col>

        <b-col cols="12">
          <label>{{ $t('landfills')}}</label>
          <area-form-repeater :items.sync="landfillsItems" :options="landfillsOption">
            <template v-slot:error>
              <b-form-invalid-feedback v-if="errors && ('landfills' in errors)"
                                       :state="errors && ('landfills' in errors) ? false : null">
                {{ $t(errors.landfills[0]) }}
              </b-form-invalid-feedback>
            </template>
          </area-form-repeater>
        </b-col>

      </b-row>

      <!-- Form Actions -->
      <div class="d-flex mt-2">
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary" class="mr-2" type="submit">
          {{ $t('Save')}}
        </b-button>
      </div>
    </b-form>
</template>

<script>

import {
BCol, BRow, BFormGroup, BFormInvalidFeedback,BFormRadioGroup,BFormCheckboxGroup,
    BButton, BForm, BFormInput
} from 'bootstrap-vue'
import AreaFormRepeater from '@/components/form/AreaFormRepeater'
import { onUnmounted, ref } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import store from '@/store'
import formGetLinkedOptions from '@/views/modules/api/formGetLinkedOptions'

export default {
  name: 'LandfillPlanForm',
  props: ['errors','planData', 'areasItems','landfillsItems', 'onSubmit'],
  components: { AreaFormRepeater,BButton,BFormCheckboxGroup, flatPickr,vSelect, BForm, BFormInput,
    BCol, BRow, BFormGroup, BFormInvalidFeedback,BFormRadioGroup
  },
  directives: { Ripple, },
  setup() {

    const user = store.getters['auth/user']

    if (!store.hasModule('formOptions'))
      store.registerModule('formOptions', formGetLinkedOptions)

    onUnmounted(() => {
      if (store.hasModule('formOptions'))
        store.unregisterModule('formOptions')
    })

    const devicesOptions = ref([])
    const campsOption = ref([])
    const areasOption = ref([])
    const landfillsOption = ref([])


    const flatPickerConfig = {
      enableTime: true,
      noCalendar: true,
      time_24hr: true,
      dateFormat: "H:i:S"
    }


    const setOptions = area => {
      switch (area.category) {
        case 'CAMP_AREA': campsOption.value.push(area); break
        case 'LANDFILL_AREA': landfillsOption.value.push(area); break
        case 'WORK_AREA': areasOption.value.push(area); break
      }
    }

    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'geofence',
      cols: 'geofence_id,name,category'
    }).then(res => res.data.data.map(a => setOptions(a))).catch(reason => {})


    store.dispatch('formOptions/getLinkedOptions', {
      user: user.id,
      type: 'device',
      cols: 'device_id,name'
    }).then(res =>  devicesOptions.value = res.data.data ).catch(reason => {})


    return {
      flatPickerConfig,
      campsOption,
      areasOption,
      landfillsOption,
      devicesOptions
    }

  }
}
</script>

<style scoped>

</style>
